// extracted by mini-css-extract-plugin
export default {"wrapper":"NFT_wrapper__U9U-8","image":"NFT_image__JN7pw","title":"NFT_title__3KHkz","price":"NFT_price__dYKLB"};